<template>
  <div class="custom-modal" id="QA" @click="clickOutside">
    <!-- Modal content -->
    <div class="modal-content">
      <h1>使用說明</h1>
      <span class="close" @click="modalClose('QAmodal')">&times;</span>
      <div class="content">
        <div class="box">
          <h2>如用戶使用本服務，即代表同意以下使用者條款、免責聲明。</h2>
        </div>
        
        <div class="box">
          <h2>新功能(new!) 同校配對</h2>
          <p style="margin:20px">目前支援的學校有:台灣、交通、清華、中央、成功、中山、台科、政治、中興、海洋、師範、中正、北科、雲科、逢甲、中原、輔仁、文化、元智、淡江、東吳。（排序僅依照IP順序，無特別意思）
          </p>
        </div>
        <div class="box">
          <h2>這是一個 隨機配對 / 限時聊天 的應用程式</h2>
          <div class="message-flex">
            <div class="message-wrapper">
              <pre class="message me">自己的框</pre>
            </div>
            <div class="message-wrapper">
              <pre class="message me success">傳送成功</pre>
            </div>
            <div class="message-wrapper">
              <pre class="message you girl">我是女孩</pre>
            </div>
            <div class="message-wrapper">
              <pre class="message you boy">我是男孩</pre>
            </div>
          </div>
          <ul>
            <li>首次開啟程式會要求設定性別、居住地，但仍然是匿名的。</li>
            <li>附近的人 - 此時只會配對到同個城市的人們。</li>
            <li>性別提示 - 配對後可以看到對方的對話框，若為粉紅色則為女孩，相反的，如果是淺藍色代表對方為男生。</li>
          </ul>
        </div>
        <div class="box">
          <h2>免責聲明</h2>
          <ul>
            <li>本服務可能會出現中斷、故障或是主機遭受網路、實體攻擊，其他使用者言語不當。</li>
            <li>造成您使用上不便，或其他經濟上、身心上損失等情形。</li>
            <li>本服務對於您因使用本服務而造成的損害，不負任何後續責任。</li>
            <li>未成年人應在法定監護人的陪同下閱讀本協議。</li>
          </ul>
        </div>
        <div class="box">
          <h2>使用者條款</h2>
          <ul>
            <li>不可 傳送任何種類的非法、恐嚇性、辱罵性、誹謗性、種族主義、淫褻、粗俗、色情、褻瀆或不雅資料</li>
            <li>不可 傳送含有騷擾或令人反感的語言</li>
            <li>不可 對本服務發動任何網路攻擊</li>
            <li>不可 在使用本服務時使用惡意腳本程式。</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: 'QAmodal',
  methods: {
    ...mapMutations('modal', ['modalClose']),

    clickOutside(e) {
      if (e.target === document.querySelector('div.custom-modal')) {
        this.modalClose('QAmodal');
      }
    }
  }
};
</script>

<style scopped lang="scss" >
#QA .message {
  font-size: 14px;
  max-width: 100%;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
